import React, { useState } from 'react'

import { SegmentFilterButton } from './Button'
import { SegmentFilterContext, useSegmentFilterContext } from './context'
import { SegmentFilterModalWrapper } from './Modal'
import { SavedFilterStructure } from '@/Atomic/Organisms/FilterBuilder'

interface SegmentFilterProviderProps {
  children: React.ReactNode
  listId?: string
}

const SegmentFilterProvider: React.FC<SegmentFilterProviderProps> = ({
  children,
  listId,
}) => {
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false)
  const [filter, setFilter] = useState<SavedFilterStructure | undefined>()

  const openFilterModal = () => {
    setIsFilterModalOpen(true)
  }

  const closeFilterModal = () => {
    setIsFilterModalOpen(false)
  }

  const saveFilter = (newFilter: SavedFilterStructure) => {
    setFilter(newFilter)
    console.log('Saved filter:', JSON.stringify(newFilter, null, 2))
  }

  return (
    <SegmentFilterContext.Provider
      value={{
        isFilterModalOpen,
        filter,
        listId,
        openFilterModal,
        closeFilterModal,
        saveFilter,
      }}
    >
      {children}
    </SegmentFilterContext.Provider>
  )
}

export const SegmentFilter = Object.assign(SegmentFilterProvider, {
  Button: SegmentFilterButton,
  Modal: SegmentFilterModalWrapper,
})

export { useSegmentFilterContext }
